// global
import React from 'react';
import PropTypes from 'prop-types';
import { Popup } from 'semantic-ui-react';

const ErrorLabel = ({ label, error, optional }) => {
    const trigger = (
        <label>
            {label} <small style={{fontWeight: 400}}>{optional === true ? '- opcional' : ''}</small>
        </label>
    );
    if (!error) {
        return trigger;
    }
    return <Popup trigger={trigger} content={error} flowing />;
};

ErrorLabel.defaultProps = {
    optional: false,
};

ErrorLabel.propTypes = {
    label: PropTypes.any.isRequired,
    error: PropTypes.any,
    optional: PropTypes.bool,
};

export default ErrorLabel;
